export const formatMoney = (num, currency = '$') => `${currency}${Number(num ?? 0)
  .toFixed(2)
  .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')}`;

export default formatMoney;
